import * as React from 'react';
import HistoricalFinancialsTable from './HistoricalFinancialsTable';

function HistoricalCashflow({data} :any) {

  function cashflowMetrics() : Array<any> {
    return [
      {
        displayName: 'Net Income',
        columnName: 'net_income_loss',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Operating Cash Flow',
        columnName: 'cashflows_from_operations',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Cash Flow, Investing',
        columnName: 'cash_flow_investing',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Cash Flow, Financing',
        columnName: 'cash_flow_financing',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Cash and Cash Equivalents',
        columnName: 'cash_equivalents',
        className: '',
        useHumanValue: true
      },
      {
        displayName: 'Free Cash Flow',
        columnName: 'free_cash_flow_human_value',
        className: 'free_cash_flow_color',
        useHumanValue: false
      }
    ]
  }

  return (
    <div className="col-lg-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Historical Cash flow</h4>
          <p className="card-description">
            Cash flow is the lifeblood of any business. To determine if a company has good cash flow, check the operating cash flow, free cash flow, and cash & cash equivalents over the last 10 years.
            We always want positive cash flow, ideally growing by at least 10% CAGR. (The data below is in {data.currency_symbol} currency)
          </p>
          <div className="table-responsive">
            <HistoricalFinancialsTable
              financialReport={data.financial_report}
              metricsDictionary={cashflowMetrics()}
              numberOfYears={data.financial_report.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoricalCashflow;
